import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import StyledTable from './StyledTable'; // adjust the path if needed
import { highlightMatch } from '../utils/highlightMatch'; // adjust path as needed
import { useTenant } from "../context/TenantContext";
import ConfirmDialog from './ConfirmDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { toast } from 'react-toastify';


const UsersList = () => {
  const [TenantUsers, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const { tenantId, loading } = useTenant();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  useEffect(() => {
    if (loading || !tenantId) return;

    const fetchUsers = async () => {
      const q = query(collection(db, "users"), where("tenantId", "==", tenantId));
      const snap = await getDocs(q);
      setUsers(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchUsers();
  }, [tenantId, loading]);

  const handleDeleteClick = (users) => {
        setUserToDelete(users);
        setConfirmOpen(true);
      };
    
      const confirmDelete = async () => {
        try {
          await deleteDoc(doc(db, 'users', userToDelete.id));
          setUsers(prev => prev.filter(p => p.id !== userToDelete.id));
          toast.success('User deleted');
        } catch (err) {
          console.error('Delete failed:', err);
          toast.error('Failed to delete');
        } finally {
          setConfirmOpen(false);
          setUserToDelete(null);
        }
      };

      const highlightMatch = (text, query) => {
  if (text === undefined || text === null) return '';
  const safeText = String(text); // Convert number or boolean to string
  if (!query) return safeText;

  const regex = new RegExp(`(${query})`, 'gi');
  const parts = safeText.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? <mark key={index}>{part}</mark> : part
  );
};

  const filtered = TenantUsers.filter(p =>
    (p.name?.toLowerCase().includes(search.toLowerCase()) ||
     String(p.name || '').includes(search))
  );

  return (
    <div className="patient-list-container">
      <div className="search-container">
        <input 
          type="text" 
          placeholder="Search by name or phone..." 
          value={search}
          onChange={e => setSearch(e.target.value)} 
        />
      </div>
      <StyledTable
        headers={['Name', 'Role', 'Phone', 'Email', 'Actions']}
        data={filtered}
        renderRow={(p) => (
          <>
            <div>{highlightMatch(p.name, search)}</div>
            <div>{highlightMatch(p.role, search)}</div>
            <div>{highlightMatch(p.phone, search)}</div>
            <div>{highlightMatch(p.email, search)}</div>
            <div className="delete-btn" onClick={() => handleDeleteClick(p)}>            
              <FontAwesomeIcon icon="trash" className="unauth-trash-icon" />
            </div>
          </>
        )}
      />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete User ?"
        message={`Are you sure you want to delete "${userToDelete?.name}"?`}
        onConfirm={confirmDelete}
        onCancel={() => setConfirmOpen(false)}
      />

    </div>
  );
};

export default UsersList;
